import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
const DeviceCredential = ProtoBaseModel.extend({
  name: attr(String),
  token: attr(String)
});
export default ProtoBaseModel.extend({
  deviceToken: attr(String),
  name: attr(String),
  deviceCredential: attr(DeviceCredential)
});